<form [formGroup]="form" class="flex flex-col justify-center items-start w-full h-auto">
  <label #subtitleLabel for="selected" class="text-label">
    {{ configSignal().label }}
  </label>

  <div
    #inbox
    class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border border-blue-700 bg-white"
  >
    <select
        id="selected"
        formControlName="selected"
        (blur)="onBlurSelect()"
        class="border-none focus:outline-none focus:ring-0 rounded px-3 w-full h-8"
        >
        <option value="" disabled hidden>{{ configSignal().placeholder }}</option>
        @for (opt of configSignal().options(); track $index) {
          <option [value]="opt.value">
            {{ opt.label }}
          </option>
        }
    </select>
  </div>

  @if (hasError()) {
    <div class="text-red-500 text-[10px] mt-1">
      {{ configSignal()?.textError }}
    </div>
  }
</form>